import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
function setupEditor(el) {
    el.removeAttribute('data-editor');
    ClassicEditor
        .create(el, {
            toolbar: {
                removeItems: [ 'uploadImage' ],
            }
        })
        .then(editor => {
            console.log(editor);
        })
        .catch(error => {
            console.error(error);
        });
}
export default function () {
    document.querySelectorAll('[data-editor]').forEach(setupEditor);
}